<template>
  <div class="page">
    <div>
      <div class="not-found">
        <h3>{{ "not_found.titles.404" | translate }}</h3>
        <div class="img"></div>
        <p>{{ "not_found.descriptions.404" | translate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundPage"
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.page {
  width: 100%;
  height: calc(
    100vh - #{$gyra-footer-min-height} - #{$gyra-header-height-mobile}
  );
  @media (min-width: $gyra-breakpoint-lg) {
    height: calc(
      100vh - #{$gyra-footer-min-height} - #{$gyra-header-smaller-height}
    );
  }
  display: flex;
  justify-content: center;
  align-items: center;
}

.not-found {
  margin: 50px 0;
  height: 500px;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.img {
  height: 200px;
  width: 100px;
  background-image: url("../assets/images/gyra_logo_big/Totem_Grey@3x.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transform: rotate(40deg);

  &::after {
    position: absolute;
    bottom: 0;
    content: "";
    width: 100px;
    height: 50px;
    border-radius: 50%;
    background-color: $gyra-grey-dark;
    transform: rotate(-40deg) translate3d(39px, -19px, 0);
    opacity: 0.2;
  }
}
p,
h3 {
  text-align: center;
}
h3 {
  font-size: 30px;
  @media (min-width: $gyra-breakpoint-md) {
    font-size: 50px;
  }
}
p {
  width: 80%;
}
</style>
